import { getDealList } from "actions/deal";
import { getProductTypeList } from "actions/productType";
import { getPublisherReportingData } from "actions/publisher";
import { getPublisherList } from "actions/publisher";
import { getAdminReportingData } from "actions/reporting";
import { formatValues } from "components/Common/commonFunctions";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import MultiselectDropDown from "components/DropDown/MultiselectDropDown";
import { getStatusBadge } from "components/Table_Details/Table_Details";
import ReactBsTable from "components/Tables/ReactBsTable";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Container, Col, Row, Button, Card } from "reactstrap";
import { DATE_RANGE_OPTIONS } from "variables/constants";
import { PRODUCT_TYPE_OPTIONS } from "variables/constants";
import { Publisher_Reporting_Data } from "variables/general";

const formatterMap = {
  grossRevenue: (value) => <span style={{ display: "block", textAlign: "right" }}>${formatValues(value)}</span>,
  Ecpm: (value) => <span style={{ display: "block", textAlign: "right" }}>{formatValues(value)}</span>,
  impressions: (value) => <span style={{ display: "block", textAlign: "right" }}>{formatValues(value)}</span>,
  adRequests: (value) => <span style={{ display: "block", textAlign: "right" }}>{formatValues(value)}</span>,
  channel: (value) => <span style={{ display: "block", textAlign: "left" }}>{value || "-"}</span>,
};

const Reporting = () => {
  const [data, setdata] = useState({
    data: Publisher_Reporting_Data || [],
    totalRecords: 0,
  });
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setpageSize] = useState(50);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const sortFieldMap = {
    date: "Date",
    month: "Month",
    totalRequest: "TotalRequests",
    totalImpressions: "TotalImpressions",
    totalFillRate: "FillRate",
    grossRevenue: "GrossRevenue",
    eRPM: "Ecpm",
    deal: "DealName",
    productTypeID: "ProductType",
    channel: "Channel",
  };

  const handleSortChange = (dataField) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;

    let newOrder = "asc";

    if (sortField === mappedSortField) {
      newOrder = sortOrder === "asc" ? "desc" : "asc";
    }

    setSortField(mappedSortField);
    setSortOrder(newOrder);
    setPageNum(1);
  };

  // Define columns for each view type
  const getColumnsByViewType = (viewType) => {

    const commonColumns = [
      {
        dataField: "totalRequest",
        text: "Requests",
        sort: true,
        sortCaret: (order, column) => {
          const mappedField = sortFieldMap[column.dataField] || column.dataField;
          const isActive = mappedField === sortField;

          if (!isActive) {
            return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
          }

          return sortOrder === "asc" ? (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
          ) : (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
          );
        },
        formatter: (cell, row) => <span style={{ display: "block", textAlign: "right" }}>{formatterMap.adRequests(row?.totalRequest) || 0}</span>,
        headerStyle: {
          textAlign: "right",
        },
      },
      {
        dataField: "totalImpressions",
        text: "Impressions",
        sort: true,
        sortCaret: (order, column) => {
          const mappedField = sortFieldMap[column.dataField] || column.dataField;
          const isActive = mappedField === sortField;

          if (!isActive) {
            return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
          }

          return sortOrder === "asc" ? (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
          ) : (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
          );
        },
        formatter: (cell, row) => <span style={{ display: "block", textAlign: "right" }}>{formatterMap.impressions(row?.totalImpressions) || 0}</span>,
        headerStyle: {
          textAlign: "right",
        },
      },
      {
        dataField: "totalFillRate",
        text: "Fill Rate",
        headerStyle: {
          textAlign: "right",
        },
        formatter: (cell, row) => {
          const requests = row?.totalRequest || 0;
          const impressions = row?.totalImpressions || 0;
          if (!requests) return "0%";
          const fillRate = (impressions / requests) * 100;
          return (
            <span style={{ display: "block", textAlign: "right" }}>{fillRate?.toFixed(2) || 0}%</span>
          )
        },
      },
      {
        dataField: "eRPM",
        text: "ERPM",
        sort: true,
        sortCaret: (order, column) => {
          const mappedField = sortFieldMap[column.dataField] || column.dataField;
          const isActive = mappedField === sortField;

          if (!isActive) {
            return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
          }

          return sortOrder === "asc" ? (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
          ) : (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
          );
        },
        formatter: (cell, row) => <span style={{ display: "block", textAlign: "right" }}>{formatterMap.Ecpm(row.eRPM?.toFixed(2)) || 0}</span>,
        headerStyle: {
          textAlign: "right",
        },
      },
      {
        dataField: "grossRevenue",
        text: "Revenue",
        sort: true,
        sortCaret: (order, column) => {
          const mappedField = sortFieldMap[column.dataField] || column.dataField;
          const isActive = mappedField === sortField;

          if (!isActive) {
            return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
          }

          return sortOrder === "asc" ? (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
          ) : (
            <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
          );
        },
        formatter: (cell, row) => <span style={{ display: "block", textAlign: "right" }}>${row?.grossRevenue?.toFixed(2) || 0}</span>,
        headerStyle: {
          textAlign: "right",
        },
      },
    ];

    switch (viewType) {
      case "DEALNAME":
        return [
          {
            dataField: "deal",
            text: "Deal Name",
            formatter: (cell, row) => row?.deal?.dealName || "-",
          },
          ...commonColumns
        ];
      case "PRODUCT":
        return [
          {
            dataField: "productTypeID",
            text: "Product Type",
            formatter: (cell, row) => row?.productTypeID?.name || "-",
          },
          ...commonColumns
        ];
      case "MONTH":
        return [
          {
            dataField: "month",
            text: "Month",
            sort: true,
            sortCaret: (order, column) => {
              const mappedField = sortFieldMap[column.dataField] || column.dataField;
              const isActive = mappedField === sortField;

              if (!isActive) {
                return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
              }

              return sortOrder === "asc" ? (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
              ) : (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
              );
            },
            formatter: (cell, row) => {
              if (!row?.month) return "-";
              const [year, month] = row.month.split('-');
              const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
              const monthIndex = parseInt(month, 10) - 1;
              return `${monthNames[monthIndex]} ${year}`;
            },
          },
          ...commonColumns
        ];
      case "DATE":
        return [
          {
            dataField: "date",
            text: "Date",
            sort: true,
            sortCaret: (order, column) => {
              const mappedField = sortFieldMap[column.dataField] || column.dataField;
              const isActive = mappedField === sortField;

              if (!isActive) {
                return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
              }

              return sortOrder === "asc" ? (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
              ) : (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
              );
            },
          },
          ...commonColumns
        ];
      case "PLACEMENT":
      case "CHANNEL":
        return [
          {
            dataField: "channel",
            text: "Channel",
            sort: true,
            sortCaret: (order, column) => {
              const mappedField = sortFieldMap[column.dataField] || column.dataField;
              const isActive = mappedField === sortField;

              if (!isActive) {
                return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
              }

              return sortOrder === "asc" ? (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
              ) : (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
              );
            },
            formatter: (cell, row) => <span style={{ display: "block", textAlign: "left" }}>{row?.channel || "-"}</span>,
          },
          ...commonColumns
        ];
      default:
        return [
          {
            dataField: "date",
            text: "Date",
            sort: true,
            sortCaret: (order, column) => {
              const mappedField = sortFieldMap[column.dataField] || column.dataField;
              const isActive = mappedField === sortField;

              if (!isActive) {
                return <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort" /></span>;
              }

              return sortOrder === "asc" ? (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-up" /></span>
              ) : (
                <span className="sort-caret" style={{ marginLeft: "8px" }}><i className="fa fa-sort-down" /></span>
              );
            },
          },
          {
            dataField: "productTypeID",
            text: "Product Type",
            formatter: (cell, row) => row?.productTypeID?.name || "-",
          },
          {
            dataField: "deal",
            text: "Deal Name",
            formatter: (cell, row) => row?.deal?.dealName || "-",
          },
          ...commonColumns
        ];
    }
  };

  const [columns, setColumns] = useState(getColumnsByViewType("DATE"));

  const [dropDownData, setDropDownData] = useState({
    productTypeData: [],
    dealData: [],
    viewType: [
      { label: "Date", value: "DATE" },
      { label: "Product", value: "PRODUCT" },
      { label: "Deal", value: "DEALNAME" },
      { label: "Month", value: "MONTH" },
      { label: "Channel", value: "PLACEMENT" },
    ],
  });
  const [showLoader, setshowLoader] = useState(false);

  const [filters, setFilters] = useState({
    deal_search: [],
    product_type: "",
    status: "",
    start_date: "",
    end_date: "",
    view_type: "DATE",
    date_range: "",
    filterParams: [],
    sort_field: "",
    sort_order: "",
  });

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));

    // Update columns when view_type changes
    if (key === "view_type" && value) {
      const newColumns = getColumnsByViewType(value);
      setColumns(newColumns);
    }
  };

  // ==> buildFilterParams function is used for to make a filterJson array.
  const buildFilterParams = () => {
    const filterParams = [];

    if (filters?.deal_search && filters.deal_search.length > 0) {
      filterParams.push({
        field: "DealID",
        condition: "in",
        filterValues: filters?.deal_search?.map(String),
      });
    }

    if (filters?.product_type !== "") {
      filterParams.push({
        field: "ProductTypeID",
        condition: "in",
        filterValues: filters?.product_type.map(String),
      });
    }

    if (filters?.start_date !== "" && filters?.end_date !== "") {
      filterParams.push({
        field: "Date",
        condition: "btw",
        filterValues: [filters?.start_date, filters?.end_date],
      });
    }

    return filterParams.length > 0 ? JSON.stringify(filterParams) : [];
  };

  // ==> isAnyFilterApplied function is used for to check is any filter is emptyor not to avoid api call.
  const isAnyFilterApplied = (filters) => {
    return Object.entries(filters).some(([key, value]) => {
      if (key === "filterParams") {
        return Array.isArray(value) && value.length > 0;
      }
      if (key === "deal_search") {
        return Array.isArray(value) && value.length > 0;
      }
      if (key === "sort_field" || key === "sort_order" || key === "date_range") {
        return false;
      }
      return value !== "" && value !== null && value !== undefined;
    });
  };

  const handleSearch = () => {
    if (!isAnyFilterApplied(filters)) return;
    const newfilterParams = buildFilterParams();
    setFilters({
      ...filters,
      filterParams: newfilterParams,
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const handleReset = () => {
    if (!isAnyFilterApplied(filters)) return;
    setFilters({
      deal_search: [],
      product_type: "",
      status: "",
      filterParams: [],
      view_type: "DATE",
      date_range: "",
      start_date: "",
      end_date: "",
      sort_field: "",
      sort_order: "",
    });
    setSortField("");
    setSortOrder("");
    setColumns(getColumnsByViewType("DATE"));
    setPageNum(1);
  };

  const getPublisherReportingList = async () => {
    try {
      setshowLoader(true);
      const res = await getPublisherReportingData(
        pageNum,
        filters,
        "",
        pageSize,
        filters.view_type,
        sortField,
        sortOrder,
      );
      if (res?.code === 200) {
        let data = res?.data;
        setdata({
          data: data.ReportingRaw,
          totalRecords: data?.totalRecords,
        });
        setshowLoader(false);
      }
      setshowLoader(false);
    } catch (error) {
      setshowLoader(false);
    }
  };

  useEffect(() => {
    getPublisherReportingList();
  }, [pageNum, filters.filterParams, pageSize, filters.view_type, sortField, sortOrder]);

  useEffect(() => {
    handleSearch();
  }, [filters.status, JSON.stringify(filters.deal_search), filters.product_type, filters.start_date, filters.end_date, filters.view_type])

  const getProductTypeData = async () => {
    try {
      const res = await getProductTypeList(
        dropDownData.productTypeData.pageNum,
        `[{"field":"Status","condition":"eq","filterValues":["ACTIVE"]}]`,
        dropDownData.productTypeData.searchString,
      );
      const productTypeData =
        res?.code === 200
          ? (res?.data?.ProductType || [])
            .filter((item) => item?.status === "ACTIVE")
            .map((item) => ({
              label: item?.name || "",
              value: item?.ID,
            }))
          : [];
      setDropDownData((prev) => ({
        ...prev,
        productTypeData: productTypeData,
      }));
      let dealFilters = [];
      if (filters.product_type) {
        dealFilters.push({
          field: "ProductTypeID",
          condition: "in",
          filterValues: filters?.product_type.map(String),
        });
      }
      const res1 = await getDealList(
        0,
        dealFilters.length > 0 ? JSON.stringify(dealFilters) : "",
        ""
      );

      const dealData = res1?.code === 200
        ? (res1?.data?.Deal || []).map((item) => ({
          label: item?.name || "",
          value: item?.ID,
        }))
        : [];

      setDropDownData((prev) => ({
        ...prev,
        dealData: dealData,
      }));
    } catch (error) { }
  };

  useEffect(() => {
    getProductTypeData();
  }, [filters.product_type]);

  const handleSizePerPageChange = (e) => {
    const newSize = Number(e.target.value);
    setpageSize(newSize);
    setPageNum(1);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // ===> showCustomDateInputs function is used for set start Date and end Date according to the selection of Date Range dropdown values.
  const showCustomDateInputs = (name, value) => {
    const today = moment().format("YYYY-MM-DD");

    if (value === "Custom Range") {
      setFilters((prev) => ({
        ...prev,
        date_range: value,
        start_date: "",
        end_date: "",
      }));
      return;
    }

    let months = 0;
    if (value === "Last 1 Month") months = 1;
    if (value === "Last 3 Month") months = 3;
    if (value === "Last 6 Month") months = 6;
    if (value === "Last 12 Month") months = 12;
    const startDate = moment().subtract(months, "months").format("YYYY-MM-DD");

    setFilters((prev) => ({
      ...prev,
      date_range: value,
      start_date: startDate,
      end_date: today,
    }));
  };

  // Function to format total row data
  const getTotalRow = () => {
    const totalRow = {
      totalRequest: data?.data?.reduce((sum, item) => sum + (item.totalRequest || 0), 0),
      totalImpressions: data?.data?.reduce((sum, item) => sum + (item.totalImpressions || 0), 0),
      grossRevenue: data?.data?.reduce((sum, item) => sum + (item.grossRevenue || 0), 0),
      eRPM: 0,
      totalFillRate: 0,
    };
    // Calculate eRPM
    if (totalRow.totalImpressions > 0) {
      totalRow.eRPM = (totalRow.grossRevenue / totalRow.totalImpressions) * 1000;
    }
    // Calculate fill rate
    if (totalRow.totalRequest > 0) {
      totalRow.totalFillRate = (totalRow.totalImpressions / totalRow.totalRequest) * 100;
    }
    return totalRow;
  };

  const filterSection = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col md={3}>
            <MultiselectDropDown
              options={dropDownData.productTypeData}
              placeholder="Product Type"
              value={filters.product_type}
              isMulti={true}
              onChange={(e) => handleChange("product_type", e.target.value)}
              isSearchable={true}
            />
          </Col>
         
          <Col md={3}>
            <MultiselectDropDown
              options={dropDownData.dealData}
              placeholder="Select Deal"
              value={filters.deal_search}
              onChange={(e) => handleChange("deal_search", e.target.value)}
              isMulti={true}
              isSearchable={true}
            />
          </Col>
          <Col md={3}>
            <SearchableDropdown
              options={dropDownData.viewType}
              placeholder="View Type"
              isClear={true}
              value={filters.view_type}
              onChange={(e) => handleChange("view_type", e.target.value)}
              isSearchable={false}
            />
          </Col>
        </Row>
        <Row className="align-items-center mt-2">
          <>
            <Col md={2}>
              <SearchableDropdown
                options={DATE_RANGE_OPTIONS}
                placeholder="Date Range"
                value={filters.date_range}
                onChange={(e) =>
                  showCustomDateInputs("date_range", e.target.value)
                }
                isSearchable={false}
              />
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={(date) =>
                    handleChange("start_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="Start Date"
                  className="form-control custom-datepicker"
                  disabled={filters.date_range !== "Custom Range"}
                />
              </div>
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.end_date ? new Date(filters.end_date) : null
                  }
                  onChange={(date) =>
                    handleChange("end_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="End Date"
                  className="form-control custom-datepicker"
                  disabled={
                    filters.date_range !== "Custom Range" || !filters.start_date
                  }
                  minDate={
                    filters.start_date
                      ? new Date(filters.start_date)
                      : undefined
                  }
                />
              </div>
            </Col>
            <Col md={4}>
              <Button
                className="secondary"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Col>
          </>
        </Row>
      </>
    );
  };

  return (
    <>
      <Container className="mt--6" fluid>
        <Card>
          <ReactBsTable
            title="Publisher Reporting"
            handleSizePerPageChange={handleSizePerPageChange}
            description="Reporting List"
            data={data?.data}
            columns={columns}
            keyField="srNo"
            showAddbtn={false}
            renderFilters={filterSection}
            page={pageNum}
            sizePerPage={pageSize}
            enablePageSizeManagement={true}
            totalRecords={data?.totalRecords}
            onPageChange={(p) => setPageNum(p)}
            onSortChange={handleSortChange}
            sortField={sortField}
            sortOrder={sortOrder}
            showLoader={showLoader}
          />
        </Card>
      </Container>
    </>
  );
};

export default Reporting;